import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-telegram.svg";
import * as styles from "./Icon.module.scss";

type TelegramProps = React.SVGProps<SVGSVGElement>;

export const Telegram = ({ className, ...props }: TelegramProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
